import { TextField } from "@mui/material";

const CodeField = ({
  value,
  onChange,
  isUpdate,
  label = "Code",
  helperText,
  ...rest
}) => (
  <TextField
    label={label}
    required
    fullWidth
    size="small"
    value={value || ""}
    disabled={isUpdate}
    onChange={(event) => onChange(event.target.value)}
    helperText={
      isUpdate ?
        "Code cannot be changed — retire this record and create a replacement instead."
      : helperText || "Stored as UPPER_SNAKE."
    }
    {...rest}
  />
);

export default CodeField;
